import { render, staticRenderFns } from "./EditTemplateSettings.vue?vue&type=template&id=18caefb7"
import script from "./EditTemplateSettings.vue?vue&type=script&lang=js"
export * from "./EditTemplateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports